import { render, staticRenderFns } from "./desktop-app-navigation.vue?vue&type=template&id=5503ae38&"
import script from "./desktop-app-navigation.vue?vue&type=script&lang=js&"
export * from "./desktop-app-navigation.vue?vue&type=script&lang=js&"
import style0 from "./desktop-app-navigation.vue?vue&type=style&index=0&id=5503ae38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports